// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__bTozw","title":"ClientInsurance_title__2DcDh","itemText":"ClientInsurance_itemText__26Tdm"};